import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Form } from 'react-bootstrap';
import { Fields, reduxForm } from 'redux-form';
import { InputBlock, FormErrorMessages, generateValidation } from 'ecs-react-components/dist/index.es';
import validations from './ConfirmEmailForm.validations';
import { messages } from './ConfirmEmailForm.i18n';
import Header from '../../components/Header/Header';
import { confirmEmailRequest } from '../../redux/modules/auth/auth-middleware';

export const fields = ['username', 'password'];

class ConfirmEmailForm extends Component {
  onLoginClick = (formValues) => {
    const creds = {
      username: formValues.username,
      password: formValues.password,
      encryptedUserId: this.props.location.search.replace('?u=', ''),
    };
    this.props.dispatch(confirmEmailRequest(creds));
  };

  renderLabel(field, messageFormatId, formatMessage) {
    return (
      <Form.Label htmlFor={field.input.name}>
        { formatMessage(messageFormatId) }
        <FormErrorMessages field={field} />
      </Form.Label>
    );
  }

  renderInputElements(field, type, messageFormId) {
    return (
      <div>
        <InputBlock
          field={ field }
          id={ field.input.name }
          type={type}
          formGroup={false}
          labelText={ <FormattedMessage { ...messageFormId } /> }
        />
      </div>
    );
  }

  renderFields = (fieldsMeta) => {
    const { username, password } = fieldsMeta;

    return (
      <div className="form-group col-lg-6">
        <div className="mb-3">
          {this.renderInputElements(
            username,
            'text',
            messages.usernameTitle.label)}
        </div>
        <div className="mb-3">
          {this.renderInputElements(
            password,
            'password',
            messages.passwordTitle.label)}
        </div>
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div>
      <Header headerTitle={<FormattedMessage { ...messages.page.title } /> } ariaDescribedby="pageInstruction"/>
          <div className="card p-3 notheme">
            <div className="card-body">
              <div className="content-area">
                <p id="pageInstruction"><FormattedMessage { ...messages.intro.label } /></p>
                <form onSubmit={handleSubmit(this.onLoginClick)}>
                  <Fields names={fields} component={this.renderFields} />
                  <Button type="button" onClick={handleSubmit(this.onLoginClick)} >
                    <FormattedMessage {...messages.login.label} />
                  </Button>
                </form>
              </div>
            </div>
          </div>
      </div>
    );
  }
}

ConfirmEmailForm.propTypes = {
  fields: PropTypes.array.isRequired,
  intl: PropTypes.object,
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  location: PropTypes.object,
};

const formConfig = {
  form: 'cofirmemailform',
  ...generateValidation(validations),
};

export default reduxForm(formConfig)(injectIntl(ConfirmEmailForm));
